import React, {useEffect, useMemo} from 'react';
import {BrowserRouter as Router, Switch, Route, Redirect} from "react-router-dom";
import Api from 'tide-api';
import apiConfig from './services/api/api-config'
import {ApiContext} from "./services/api/api-config";
import './assets/fonts/fonts-def.scss';
import './assets/fonts/fonts.scss';
import '../src/assets/styles/App.scss';
import 'bootstrap/scss/bootstrap.scss';
import {LOGIN_STATE} from "tide-api";
import store from "./services/redux/store";
import {useSelector} from "react-redux";
import Splash from "./components/Splash";
import SecurityManager, {SecurityContext} from "./services/SecurityManager";
import getMainRoutes from "./services/routes/mainRoutes";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import TideToaster from "./components/TideToaster/TideToaster";
import {notifierRef} from "./services/notifier";
import Package from "./pckg.json";
import LoadingNotification from './components/LoadingNotification/LoadingNotification';

const api = new Api({...apiConfig, reduxStore: store});

function App() {

    const loggedIn=useSelector(({api})=>api.loggedIn===LOGIN_STATE.LOGGED_IN);

    const loading=useSelector(({loadingIds})=>!!loadingIds['Initializing.me']);
    const isLoadingRequest =useSelector(({loading})=>!!loading);
    const me=useSelector(({api})=>api.me);

    localStorage.version = Package.version

    useEffect(()=>{
        if(!me && !loading && loggedIn)
            api.me.get({loadingId:'Initializing.me'}).catch(()=>api.logout());
    },[me, loading, loggedIn]);

    const securityManager=useMemo(()=> me? new SecurityManager(me) : null,[me]);

    const routes = getMainRoutes(loggedIn && me);

    const splash = loading || (loggedIn && !me);

    return (
        <div className="App">
            <TideToaster ref={notifierRef}/>
            <SecurityContext.Provider value={securityManager}>
                <ApiContext.Provider value={api} >
                    <ErrorBoundary>
                        <Router>
                            {splash ?
                                <Splash/>
                                :
                                <>
                                <Switch>
                                    {routes.map(route =>
                                        <Route key={route.path} path={route.path} component={route.component}
                                               exact={route.exact === true}/>
                                    )}
                                    <Redirect from='/' to={routes[0].path}/>
                                </Switch>
                                {isLoadingRequest ? <LoadingNotification/> : null }
                                </>
                            }
                        </Router>
                    </ErrorBoundary>
                </ApiContext.Provider>
            </SecurityContext.Provider>
        </div>
    );
}

App.displayName="App";

export default App;
